<app-global-data (OnCountryListReady)="OnCountryList($event)"></app-global-data>
<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
  (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

<div *ngIf="bShowCifSearchScreen">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      <form cForm class="row g-2" [formGroup]="cifSearchForm" (ngSubmit)="getCifDetails()">
        <div class="row row-cols-auto">
          <div class="col-md-auto">
            <c-input-group class="mb-3 has-validation">
              <span cInputGroupText>
                CIF
              </span>
              <input cFormControl formControlName="searchCifControl" id="CIF" placeholder="Company CIF" type="text" />
            </c-input-group>
          </div>
          <div class="col-sm-auto">
            <button cBgColor="{{searchBtnColor}}" cButton type="submit">
              Search
            </button>
          </div>
          <div class="col-sm-auto">
            <button cBgColor="{{showRejectCustomerBtnColor}}" cButton type="button" (click)="getRejectedCustomerCif()">
              Show Rejected Customers
            </button>
          </div>
          <div class="col-sm-auto">
            <button cBgColor="{{showAllRejectCustomerBtnColor}}" cButton type="button"
              (click)="getAllRejectedCustomers()">
              Show All Rejected Customers
            </button>
          </div> 
        </div>
        <div class="row row-cols-auto">
          <div class="col">{{companyName}}</div>
        </div>
      </form>

    </c-container>
  </c-navbar>

  <c-smart-table [columnSorter]="true" [columns]="columns" [columnFilter]="true" [itemsPerPageSelect]="true"
    [items]="usersData" [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }" (rowClick)="rowSelected($event)" clickableRows
    header pagination>
    <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
      <td>
        <ng-container [ngSwitch]="columnName">
          <ng-container *ngSwitchCase="'createdOn'">
            {{(getDateDisplayString(item))}}
          </ng-container>
          <ng-container *ngSwitchCase="'isMaker'">
            <c-badge [color]="getRoleBadge(item)">
              {{(getRole(item))}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchCase="'isCIFLevelAuthority'">
            <c-badge [color]="getAuthorityLevelBadge(item)">
              {{(getAuthorityLevel(item))}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchCase="'isApproved'">
            <c-badge [color]="getStatusBadge(item)">
              {{(getStatus(item))}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{tdContent}}
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </c-smart-table>
</div>

<div *ngIf="bShowCustomerDetailsScreen" class="main-height">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      {{companyName}}
      <button [cNavbarToggler]="toolbarCollapseRef"></button>
      <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
        <c-navbar-nav class="me-auto mb-2 mb-lg-0">

        </c-navbar-nav>
        <!-- {{bNewCustomer}} -->
        <form cForm class="d-flex" role="search">
          <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton
            (click)="goBackToSearchScreen()"><svg cIcon name="cilChevronDoubleLeft"></svg></button>
          <!-- <button cBgColor="danger" *ngIf="!bNewCustomer && bUserRejected && !rejectionReason"
            cTooltip="Deactivate Customer" cTooltipPlacement="top" style="margin: 5px;" cButton
            (click)="deactivateCustomerPrompt(1)"><svg cIcon name="cilUserX"></svg></button>
          <button cBgColor="success" *ngIf="!bNewCustomer && !bUserRejected && !rejectionReason"
            cTooltip="Activate Customer" cTooltipPlacement="top" style="margin: 5px;" cButton
            (click)="deactivateCustomerPrompt(0)"><svg cIcon name="cilUserX"></svg></button>
          <button cTooltip="Reset Customer Data" *ngIf="bNewCustomer" cTooltipPlacement="top" style="margin: 5px;"
            cButton (click)="this.showCreateCustomerScreen()"><svg cIcon name="cilHistory"></svg></button>
          <button cTooltip="Edit Customer" cTooltipPlacement="top" *ngIf="bViewOnly" style="margin: 5px;" cButton
            (click)="enableEditing()"><svg cIcon name="cilPencil"></svg></button>
          <button cTooltip="Save Customer" cTooltipPlacement="top" *ngIf="showSaveButton()" style="margin: 5px;" cButton
            (click)="saveCustomerPrompt()"><svg cIcon name="cilSave"></svg></button>
          <button cTooltip="Proceed" cTooltipPlacement="top" *ngIf="bViewOnly" style="margin: 5px;" cButton
            (click)="proceed()"><svg cIcon name="cilChevronDoubleRight"></svg></button> -->
        </form>
      </div>
    </c-container>
  </c-navbar>
  <p *ngIf="!bNewCustomer && rejectionReason" class="fw-medium text-danger">Rejection Reason: {{rejectionReason}}</p>
  <div class="row g-2 pt-4 ">
    <c-nav variant="underline">
      <a [active]="profileTabActive" [cTabContent]="tabContent" [routerLink] [tabPaneIdx]="0" cNavLink>Customer
        Profile</a>
      <a [active]="matrixTabActive" [cTabContent]="tabContent" [routerLink] [tabPaneIdx]="1" cNavLink>Customer Authority
        Matrix</a>

    </c-nav>
    <c-tab-content #tabContent="cTabContent" [activeTabPaneIdx]="selectedTab"
      (activeTabPaneIdxChange)="activeTabPaneIdxChange($event)">
      <c-tab-pane class="p-3">
        <div class="container">
          <form cForm [formGroup]="customerProfileForm" class="needs-validation" [gutter]="3">
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col"><label cLabel for="inputName">Name</label></div>
                  <div *ngIf="bApprovedName" class="col"><small><a (click)="showApprovedProfile($event, 1)" href=""
                        style="float: right;">{{bShowingApprovedName?'Show Approved':'Show Saved'}}</a></small></div>
                </div>
                <input [valid]="customerNameValid" cFormControl id="inputName" type="text"
                  formControlName="customerName" />
                <c-form-feedback
                  [valid]="isCustomerNameValid() === ''?true:false">{{isCustomerNameValid()}}</c-form-feedback>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col"><label cLabel for="inputEmail">Email Id</label></div>
                  <div *ngIf="bApprovedEmail" class="col"><small><a (click)="showApprovedProfile($event, 2)" href=""
                        style="float: right;">{{bShowingApprovedEmail?'Show Approved':'Show Saved'}}</a></small></div>
                </div>
                <input [valid]="customerEmailValid" cFormControl id="inputEmail" type="email"
                  formControlName="customerEmail" />
                <c-form-feedback
                  [valid]="isCustomerEmailValid() === ''?true:false">{{isCustomerEmailValid()}}</c-form-feedback>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                <div class="row">
                  <div class="col"><label cLabel for="inputMobileNumber">Mobile Number</label></div>
                  <div *ngIf="bApprovedMobile" class="col"><small><a (click)="showApprovedProfile($event, 3)" href=""
                        style="float: right;">{{bShowingApprovedMobile?'Show Approved':'Show Saved'}}</a></small></div>
                </div>
                <input [valid]="customerMobileValid" cFormControl id="inputMobileNumber" placeholder="Mobile Number"
                  formControlName="customerMobile" />
                <c-form-feedback
                  [valid]="isCustomerMobileValid() === ''?true:false">{{isCustomerMobileValid()}}</c-form-feedback>
              </div>
              <div class="col-4">
                <div class="row">
                  <div class="col"><label cLabel for="inputGender">Gender</label></div>
                  <div *ngIf="bApprovedGender" class="col"><small><a (click)="showApprovedProfile($event, 4)" href=""
                        style="float: right;">{{bShowingApprovedGender?'Show Approved':'Show Saved'}}</a></small></div>
                </div>
                <select [valid]="customerGenderValid" cSelect id="inputGender" name="inputGender"
                  formControlName="customeGender">
                  <option>Male</option>
                  <option>Female</option>
                </select>
                <c-form-feedback
                  [valid]="isCustomerGenderValid() === ''?true:false">{{isCustomerGenderValid()}}</c-form-feedback>
              </div>
              <div class="col-4">
                <div class="row">
                  <div class="col">
                    <label cLabel for="inputDateOfBirth">Date Of Birth</label>
                  </div>
                  <div *ngIf="bApprovedDOB" class="col"><small><a (click)="showApprovedProfile($event, 5)" href=""
                        style="float: right;">{{bShowingApprovedDOB?'Show Approved':'Show Saved'}}</a></small></div>
                </div>
                <c-date-picker [valid]="customerDOBValid" [inputReadOnly]="true" [maxDate]="minDateOfBirth"
                  closeOnSelect cFormControl id="inputDateOfBirth" [(date)]="selectedCustomerDateOfBirth"
                  formControlName="customeDateOfBirth" />
                <c-form-feedback style="
                display: block !important;
            " [valid]="isCustomerDOBValid() === ''?true:false">{{isCustomerDOBValid()}}</c-form-feedback>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col">
                <div class="row">
                  <div class="col"><label cLabel for="inputIdType">ID Type</label></div>
                  <div *ngIf="bApprovedIDType" class="col"><small><a (click)="showApprovedProfile($event, 6)" href=""
                        style="float: right;">{{bShowingApprovedIDType?'Show Approved':'Show Saved'}}</a></small></div>
                </div>
                <select [valid]="customerIDTypeValid" cSelect id="inputIdType" name="inputIdType"
                  formControlName="customerIDType">
                  <option>Passport</option>
                  <option>Emirates ID</option>
                </select>
                <c-form-feedback
                  [valid]="isCustomerIDTypeValid() === ''?true:false">{{isCustomerIDTypeValid()}}</c-form-feedback>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col"><label cLabel for="inputIdNumber">ID Number</label></div>
                  <div *ngIf="bApprovedIDNumber" class="col"><small><a (click)="showApprovedProfile($event, 7)" href=""
                        style="float: right;">{{bShowingApprovedIDNumber?'Show Approved':'Show Saved'}}</a></small>
                  </div>
                </div>
                <input [valid]="customerIDNumberValid" cFormControl id="inputIdNumber" placeholder="ID Number"
                  formControlName="customerIDNumber" />
                <c-form-feedback
                  [valid]="isCustomerIDNumberValid() === ''?true:false">{{isCustomerIDNumberValid()}}</c-form-feedback>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col"><label cLabel for="inputNationality">Nationality</label></div>
                  <div *ngIf="bApprovedNationality" class="col"><small><a (click)="showApprovedProfile($event, 8)"
                        href="" style="float: right;">{{bShowingApprovedNationaility?'Show Approved':'Show
                        Saved'}}</a></small></div>
                </div>
                <select [valid]="customerNationalityValid" cSelect id="inputNationality" name="inputNationality"
                  formControlName="customerNationality">
                  <option *ngFor="let country of countryList?.dhabiCountries" id="countryList"
                    [value]="country.shortCode">{{country.countryName}}</option>
                </select>
                <c-form-feedback
                  [valid]="isCustomerNationalityValid() === ''?true:false">{{isCustomerNationalityValid()}}</c-form-feedback>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label cLabel for="inputExpiresOn">Expires On</label>
                  </div>
                  <div *ngIf="bApprovedIDExpiry" class="col"><small><a (click)="showApprovedProfile($event, 9)" href=""
                        style="float: right;">{{bShowingApprovedIDExpiry?'Show Approved':'Show Saved'}}</a></small>
                  </div>
                </div>
                <c-date-picker [inputReadOnly]="true" [valid]="customerIDExpiryValid" [minDate]="minIDExpiryDate"
                  closeOnSelect cFormControl id="inputExpiresOn" [(date)]="selectedCustomerIDExpiresOn"
                  formControlName="customerIDExpiryDate" />
                <c-form-feedback class="d-block"
                  [valid]="isCustomerIDExpiryValid() === ''?true:false">{{isCustomerIDExpiryValid()}}</c-form-feedback>
              </div>
            </div>
          </form>
        </div>
      </c-tab-pane>
      <c-tab-pane class="p-3">
        <p *ngIf="selectedSearchButton == 2 || selectedSearchButton == 3" class="fst-italic">Please note that only the
          rejected permissions are shown below. For approved permissions, please view the customer details</p>
        <div class="container">
          <form cForm>
            <div *ngIf="bHasCustomerMatrixApprovalPending" class="row"
              style="justify-content: flex-end; display: flex; margin-right: auto;">
              <button *ngIf="bShowingApprovedData" cTextColor="white" color="warning" style="margin: 5px;" cButton
                (click)="showApprovedOrPendingScreen(false)">{{topScreenMessage}}</button>
              <button *ngIf="!bShowingApprovedData" cTextColor="white" color="danger" style="margin: 5px;" cButton
                (click)="showApprovedOrPendingScreen(true)">{{topScreenMessage}}</button>
            </div>
            <div class="row g-2 pb-3">
              <div class="col-2">
                <label cLabel for="inputName">Role</label>
                <select [disabled]="bViewOnly" cSelect id="inputRoleType" name="inputRoleType"
                  [(ngModel)]="selectedCustomerRole" (change)="switchRole($event)"
                  (ngModelChange)="matrixChange($event)">
                  <option>Maker</option>
                  <option>Checker</option>
                </select>
              </div>
              <div class="col-2">
                <label cLabel for="inputEmail">Authority Level</label>
                <select [disabled]="bViewOnly" cSelect id="inputAuthorityType" name="inputAuthorityType"
                  [(ngModel)]="selectedCustomerAuthorityLevel" (change)="switchAuthorityLevel($event)"
                  (ngModelChange)="matrixChange($event)">
                  <option>CIF</option>
                  <option>Account</option>
                </select>
              </div>


              <!-- Account permissions are managed in the grid below when Authority Level = Account -->
            </div>

            <c-nav variant="underline">
              <a [active]="true" [cTabContent]="authorityContent" [routerLink] [tabPaneIdx]="0" cNavLink>Master
                Authorities</a>
              <a [active]="false" [cTabContent]="authorityContent" [routerLink] [tabPaneIdx]="1"
                cNavLink>{{authorityLevelTabLabel}}</a>
              <!-- <a *ngFor="let account2 of val"  [active]="false" [cTabContent]="authorityContent" [routerLink] [tabPaneIdx]="1" cNavLink> <p > {{account2.accountNumber}}</p></a> -->
            </c-nav>
            <c-tab-content #authorityContent="cTabContent">
              <c-tab-pane class="p-3">
                <div class="row g-2 pb-3">
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerFullMasterAuthority" (click)="setMasterAuthority(0)" />
                      <label cFormCheckLabel>All Master Authorities</label>
                    </c-form-check>
                  </div>
                </div>

                <div class="row g-2">

                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerCreateSB" (click)="setMasterAuthority(2)" />
                      <label cFormCheckLabel>Can Create Savings A/c</label>
                    </c-form-check>
                  </div>
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input cFormCheckInput [disabled]="bViewOnly" type="checkbox"
                        [checked]="bSelectedCustomerCreateCurrent" (click)="setMasterAuthority(3)" />
                      <label cFormCheckLabel>Can Create Current A/c</label>
                    </c-form-check>
                  </div>
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerRequestCertificate" (click)="setMasterAuthority(9)" />
                      <label cFormCheckLabel>Can Request Certificate</label>
                    </c-form-check>
                  </div>
                  <!--  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerChangeMobile" (click)="setMasterAuthority(5)" />
                      <label cFormCheckLabel>Can Change Mobile</label>
                    </c-form-check>
                  </div> -->
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerChangeAddress" (click)="setMasterAuthority(4)" />
                      <label cFormCheckLabel>Can Change Address</label>
                    </c-form-check>
                  </div>
                  <!--<div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerChangeEmail" (click)="setMasterAuthority(6)" />
                      <label cFormCheckLabel>Can Change Email</label>
                    </c-form-check>
                  </div> -->
                </div>
              </c-tab-pane>
              <c-tab-pane class="p-3">
                <div *ngIf="bSelectedCustomerCIFLevelAuthority" class="row g-2 pb-3">
                 <!-- <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerViewOnly" (click)="setCIFAuthority(15, $event)" />
                      <label cFormCheckLabel>Can Only View Accounts</label>
                    </c-form-check>
                  </div>-->
                  <div class="col-3">
                    <c-form-check [switch]="true">
                      <input [disabled]="bViewOnly" cFormCheckInput type="checkbox"
                        [checked]="bSelectedCustomerDeactivateAccount" (click)="setCIFAuthority(16, $event)" />
                      <label cFormCheckLabel>Can Deactivate Accounts</label>
                    </c-form-check>
                  </div>
                </div>
                <div *ngIf="bSelectedCustomerCIFLevelAuthority" class="table-responsive mb-4">
                  <table class="table table-hover align-middle mb-0">
                    <thead>
                      <tr>
                        <th>
                          <div class="d-flex align-items-center justify-content-between gap-2">
                            <span>Authority Type</span>
                            <c-form-check [switch]="true" class="mb-0">
                              <input disabled readonly cFormCheckInput type="checkbox" [checked]="isAllCifThresholdAuthoritiesEnabled()" />
                              <label cFormCheckLabel>Enable All</label>
                            </c-form-check>
                          </div>
                        </th>
                        <th class="text-center" *ngFor="let currency of cifSupportedCurrencies">{{currency}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of cifThresholdRows">
                        <td>
                          <div class="d-flex align-items-center justify-content-between gap-2">
                            <span class="fw-medium">{{row.label}}</span>
                            <c-form-check [switch]="true" class="mb-0">
                              <input disabled readonly cFormCheckInput type="checkbox" [checked]="getCifMatrixEnabled(row.matrixId)" />
                            </c-form-check>
                          </div>
                        </td>
                        <td *ngFor="let currency of cifSupportedCurrencies">
                          <div class="d-flex align-items-center gap-2">
                            <c-input-group class="flex-grow-1 mb-0 has-validation">
                              <input
                                disabled readonly
                                class="text-end"
                                cFormControl
                                [placeholder]="getCifThresholdCell(row.matrixId, currency).unlimited ? 'Unlimited' : 'Threshold'"
                                [value]="getCifThresholdCell(row.matrixId, currency).unlimited ? '' : ((getCifThresholdCell(row.matrixId, currency).threshold > 0 ? getCifThresholdCell(row.matrixId, currency).threshold : 0) | number: '0.0-0': 'en')"
                                type="text" />
                            </c-input-group>
                            <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                              <input disabled readonly cFormCheckInput type="checkbox" [checked]="getCifThresholdCell(row.matrixId, currency).unlimited" />
                              <label cFormCheckLabel>Max</label>
                            </c-form-check>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Account Level Authorities grid: shown when Authority Level = Account -->
                <div *ngIf="!bSelectedCustomerCIFLevelAuthority" class="table-responsive mb-4"
                  style="max-height: 50vh; overflow-y: auto; padding-bottom: 3rem;">
                  <table class="table table-hover align-middle mb-0">
                    <thead style="position: sticky; top: 0; background: var(--cui-body-bg, #fff); z-index: 1;">
                      <tr>
                        <th style="width: 60px;">
                          <c-form-check [switch]="true">
                            <input
                              [disabled]="bViewOnly"
                              cFormCheckInput type="checkbox" [checked]="allAccountsSelected"
                              (click)="toggleAllAccountsSelectAll()" />
                          </c-form-check>
                        </th>
                        <th>Accounts</th>
                        <th class="text-center">
                          <c-form-check [switch]="true">
                            <input
                              [disabled]="bViewOnly"
                              cFormCheckInput type="checkbox" [checked]="allFDSelected"
                              (click)="toggleAccountColumnSelectAll('fd', 1)" />
                            <label cFormCheckLabel>Fixed Deposits</label>
                          </c-form-check>
                        </th>
                        <th class="text-center">
                          <c-form-check [switch]="true">
                            <input
                              [disabled]="bViewOnly"
                              cFormCheckInput type="checkbox" [checked]="allInternalSelected"
                              (click)="toggleAccountColumnSelectAll('internal', 14)" />
                            <label cFormCheckLabel>Internal Transfer</label>
                          </c-form-check>
                        </th>
                        <th class="text-center">
                          <c-form-check [switch]="true">
                            <input
                              [disabled]="bViewOnly"
                              cFormCheckInput type="checkbox" [checked]="allDhabiSelected"
                              (click)="toggleAccountColumnSelectAll('dhabi', 12)" />
                            <label cFormCheckLabel>Transfer within Dhabi</label>
                          </c-form-check>
                        </th>
                        <th class="text-center">
                          <c-form-check [switch]="true">
                            <input
                              [disabled]="bViewOnly"
                              cFormCheckInput type="checkbox" [checked]="allForeignSelected"
                              (click)="toggleAccountColumnSelectAll('foreign', 13)" />
                            <label cFormCheckLabel>Foreign Transfer</label>
                          </c-form-check>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of accountMatrixRows">
                        <td>
                          <c-form-check [switch]="true">
                            <input
                              [disabled]="bViewOnly"
                              cFormCheckInput type="checkbox" [checked]="row.rowEnabled"
                              (click)="toggleAccountRow(row)" />
                          </c-form-check>
                        </td>
                        <td class="fw-medium">{{row.accountNumber}} {{row.currency || 'USD'}}</td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <c-input-group class="flex-grow-1 mb-0">
 
                              <input class="text-end" cFormControl placeholder="Threshold"
                                [disabled]="bViewOnly || !row.fd.enabled || row.fd.unlimited"
                                [value]="row.fd.unlimited ? 'Unlimited' : ((row.fd.threshold > 0 ? row.fd.threshold : 0) | number: '0.0-0': 'en')"
                                (keyup)="onAccountCellThresholdChange($event, row, 'fd', 1)" />
                            </c-input-group>
                            <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                              <input
                                [disabled]="bViewOnly || !row.fd.enabled"
                                cFormCheckInput type="checkbox" [checked]="row.fd.unlimited"
                                (click)="onAccountCellUnlimitedToggle(row, 'fd', 1)" />
                              <label cFormCheckLabel>Unlimited</label>
                            </c-form-check>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <c-input-group class="flex-grow-1 mb-0">
 
                              <input class="text-end" cFormControl placeholder="Threshold"
                                [disabled]="bViewOnly || !row.internal.enabled || row.internal.unlimited"
                                [value]="row.internal.unlimited ? 'Unlimited' : ((row.internal.threshold > 0 ? row.internal.threshold : 0) | number: '0.0-0': 'en')"
                                (keyup)="onAccountCellThresholdChange($event, row, 'internal', 14)" />
                            </c-input-group>
                            <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                              <input
                                [disabled]="bViewOnly || !row.internal.enabled"
                                cFormCheckInput type="checkbox" [checked]="row.internal.unlimited"
                                (click)="onAccountCellUnlimitedToggle(row, 'internal', 14)" />
                              <label cFormCheckLabel>Unlimited</label>
                            </c-form-check>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <c-input-group class="flex-grow-1 mb-0">
 
                              <input class="text-end" cFormControl placeholder="Threshold"
                                [disabled]="bViewOnly || !row.dhabi.enabled || row.dhabi.unlimited"
                                [value]="row.dhabi.unlimited ? 'Unlimited' : ((row.dhabi.threshold > 0 ? row.dhabi.threshold : 0) | number: '0.0-0': 'en')"
                                (keyup)="onAccountCellThresholdChange($event, row, 'dhabi', 12)" />
                            </c-input-group>
                            <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                              <input
                                [disabled]="bViewOnly || !row.dhabi.enabled"
                                cFormCheckInput type="checkbox" [checked]="row.dhabi.unlimited"
                                (click)="onAccountCellUnlimitedToggle(row, 'dhabi', 12)" />
                              <label cFormCheckLabel>Unlimited</label>
                            </c-form-check>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <c-input-group class="flex-grow-1 mb-0">
 
                              <input class="text-end" cFormControl placeholder="Threshold"
                                [disabled]="bViewOnly || !row.foreign.enabled || row.foreign.unlimited"
                                [value]="row.foreign.unlimited ? 'Unlimited' : ((row.foreign.threshold > 0 ? row.foreign.threshold : 0) | number: '0.0-0': 'en')"
                                (keyup)="onAccountCellThresholdChange($event, row, 'foreign', 13)" />
                            </c-input-group>
                            <c-form-check [switch]="true" class="mb-0 flex-shrink-0">
                              <input
                                [disabled]="bViewOnly || !row.foreign.enabled"
                                cFormCheckInput type="checkbox" [checked]="row.foreign.unlimited"
                                (click)="onAccountCellUnlimitedToggle(row, 'foreign', 13)" />
                              <label cFormCheckLabel>Unlimited</label>
                            </c-form-check>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="!accountMatrixRows.length">
                        <td colspan="6" class="text-center text-muted">No company accounts available.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </c-tab-pane>
            </c-tab-content>
          </form>
        </div>
      </c-tab-pane>
    </c-tab-content>
  </div>
</div>
